import React, { useState } from 'react';
import Type from 'prop-types';
import { PhoneMenu } from 'components/PhoneIconButton';
import styles from './PhoneNumberInline.module.css';

export const PhoneNumberInline = (props) => {
  const { phone } = props;
  const [anchorEl, setAnchorEl] = useState(null);

  if (!phone) {
    return <span>------------------</span>;
  }

  const openMenu = (event) => setAnchorEl(event.currentTarget);
  const closeMenu = () => setAnchorEl(null);

  return (
    <>
      <span
        className={styles.phoneText}
        onClick={openMenu}
        role="button"
        tabIndex={0}
      >
        {phone}
      </span>
      <PhoneMenu
        phone={phone}
        anchorEl={anchorEl}
        closeMenu={closeMenu}
        additionalWrapperStyles={[styles.phoneMenu]}
      />
    </>
  );
};

PhoneNumberInline.propTypes = {
  phone: Type.string.isRequired,
};
